exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SaveButton-saveBtn-1bvyP {\r\n\tline-height: 43px;\r\n}\r\n\r\nspan {\r\n\ttext-decoration: none;\r\n}\r\n\r\nspan:hover, span:active, span:focus, span:visited {\r\n\ttext-decoration: none !important;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"saveBtn": "SaveButton-saveBtn-1bvyP"
};